/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type ReputationTagsUpdatedEvent = {
  agent: Address;
  totalTags: number;
  skillTagsCount: number;
  behaviorTagsCount: number;
  complianceTagsCount: number;
  tagScoresCount: number;
  timestamp: bigint;
};

export type ReputationTagsUpdatedEventArgs = {
  agent: Address;
  totalTags: number;
  skillTagsCount: number;
  behaviorTagsCount: number;
  complianceTagsCount: number;
  tagScoresCount: number;
  timestamp: number | bigint;
};

export function getReputationTagsUpdatedEventEncoder(): FixedSizeEncoder<ReputationTagsUpdatedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["totalTags", getU32Encoder()],
    ["skillTagsCount", getU32Encoder()],
    ["behaviorTagsCount", getU32Encoder()],
    ["complianceTagsCount", getU32Encoder()],
    ["tagScoresCount", getU32Encoder()],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getReputationTagsUpdatedEventDecoder(): FixedSizeDecoder<ReputationTagsUpdatedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["totalTags", getU32Decoder()],
    ["skillTagsCount", getU32Decoder()],
    ["behaviorTagsCount", getU32Decoder()],
    ["complianceTagsCount", getU32Decoder()],
    ["tagScoresCount", getU32Decoder()],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getReputationTagsUpdatedEventCodec(): FixedSizeCodec<
  ReputationTagsUpdatedEventArgs,
  ReputationTagsUpdatedEvent
> {
  return combineCodec(
    getReputationTagsUpdatedEventEncoder(),
    getReputationTagsUpdatedEventDecoder(),
  );
}
